import React from 'react'
import { func } from 'prop-types'
import useInternationalization from '@hooks/useInternationalization'

import { UnitedStatesRoundedFlag, BrazilRoundedFlag } from '@assets/icons'

import * as Style from './LocationButton.style'

function LocationButton({ onClick }) {
  const { country, language } = useInternationalization()

  const flagByCountry = {
    us: UnitedStatesRoundedFlag,
    br: BrazilRoundedFlag,
  }

  return (
    <Style.LocationButton onClick={onClick}>
      <Style.Icon
        src={flagByCountry[country]}
        alt={`The current selected country is ${country}`}
      />
      <Style.Text>{language}</Style.Text>
      <Style.ArrowDown />
    </Style.LocationButton>
  )
}

LocationButton.propTypes = {
  onClick: func.isRequired,
}

export default LocationButton
